// File: src/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  doc, 
  getDoc, 
  setDoc, 
  addDoc, 
  updateDoc, 
  serverTimestamp,
  query,
  orderBy,
  getDocs,
  limit,
  where,
  deleteDoc,
  writeBatch, // Add this import
} from 'firebase/firestore';
import { 
  getStorage, 
  ref as storageRef, 
  uploadBytes, 
  getDownloadURL,
  deleteObject
} from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Replace with your Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyC1-8ADFqqlnt--9tAeHDlbxPqyT2aJw3I",
    authDomain: "cobra-shop-loyalty.firebaseapp.com",
    projectId: "cobra-shop-loyalty",
    storageBucket: "cobra-shop-loyalty.firebasestorage.app",
    messagingSenderId: "666580371424",
    appId: "1:666580371424:web:1468d3e16d0aa59dc10d85"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Add to your firebase.js file

// Function to get monthly points data for charts
// Function to get monthly points data for charts
export const getMonthlyPointsData = async () => {
    try {
      console.log("Getting monthly points data...");
      const transactionsRef = collection(db, "transactions");
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
      
      const q = query(
        transactionsRef, 
        orderBy("timestamp", "desc"),
        limit(100) // Limit to recent transactions for performance
      );
      
      console.log("Executing monthly points query...");
      const querySnapshot = await getDocs(q);
      console.log(`Found ${querySnapshot.size} transactions for monthly points calculation`);
      
      // Check field names in first transaction
      if (querySnapshot.size > 0) {
        const firstDoc = querySnapshot.docs[0];
        const firstTransaction = firstDoc.data();
        console.log("Sample transaction fields:", Object.keys(firstTransaction));
      }
      
      // Group by month
      const monthlyData = {};
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      
      querySnapshot.forEach((doc) => {
        const transaction = doc.data();
        if (transaction.timestamp) {
          try {
            const date = transaction.timestamp.toDate();
            if (date >= sixMonthsAgo) {
              const monthKey = monthNames[date.getMonth()];
              
              if (!monthlyData[monthKey]) {
                monthlyData[monthKey] = 0;
              }
              
              // Get points value - support different field names if needed
              const pointsValue = transaction.points !== undefined ? 
                Number(transaction.points) : 0;
                
              monthlyData[monthKey] += pointsValue;
            }
          } catch (err) {
            console.error("Error processing transaction for monthly points:", err);
          }
        }
      });
      
      // Convert to array format for chart and ensure all months appear
      const result = [];
      const currentMonth = new Date().getMonth();
      
      for (let i = 5; i >= 0; i--) {
        const monthIndex = (currentMonth - i + 12) % 12; // Handle wrapping around to previous year
        const month = monthNames[monthIndex];
        result.push({
          month: month,
          points: monthlyData[month] || 0
        });
      }
      
      console.log("Monthly points data calculated:", result);
      return result;
    } catch (err) {
      console.error("Error getting monthly points data:", err);
      // Return empty array with month names to avoid errors in the chart
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const currentMonth = new Date().getMonth();
      const result = [];
      
      for (let i = 5; i >= 0; i--) {
        const monthIndex = (currentMonth - i + 12) % 12;
        result.push({
          month: monthNames[monthIndex],
          points: 0
        });
      }
      
      return result;
    }
  };
  
//   export const redeemPoints = async (customerId, pointsToRedeem, rewardName) => {
//     try {
//       // 1. Update customer's points
//       const customerRef = doc(db, "customers", customerId);
//       const customerSnap = await getDoc(customerRef);
      
//       if (!customerSnap.exists()) {
//         throw new Error("Customer not found");
//       }
      
//       const customerData = customerSnap.data();
//       const currentPoints = customerData.totalPoints || 0;
      
//       if (currentPoints < pointsToRedeem) {
//         throw new Error("Not enough points for redemption");
//       }
      
//       const newTotalPoints = currentPoints - pointsToRedeem;
      
//       await updateDoc(customerRef, {
//         totalPoints: newTotalPoints,
//         lastActive: serverTimestamp()
//       });
      
//       // 2. Add redemption record
//       const redemptionRef = collection(db, "redemptions");
//       await addDoc(redemptionRef, {
//         customerId: customerId,
//         customerName: customerData.name,
//         pointsRedeemed: pointsToRedeem,
//         rewardName: rewardName,
//         status: "Completed",
//         timestamp: serverTimestamp()
//       });
      
//       return {
//         success: true,
//         customer: { id: customerSnap.id, ...customerData, totalPoints: newTotalPoints }
//       };
//     } catch (error) {
//       console.error("Error redeeming points:", error);
//       throw error;
//     }
//   };
  
  // Function to get actual redemption history
  export const getActualRedemptionHistory = async () => {
    try {
      const redemptionsRef = collection(db, "redemptions");
      const q = query(redemptionsRef, orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      
      const redemptions = [];
      querySnapshot.forEach((doc) => {
        redemptions.push({ id: doc.id, ...doc.data() });
      });
      
      return {
        history: redemptions
      };
    } catch (error) {
      console.error("Error getting redemption history:", error);
      throw error;
    }
  };

  // Add this function to your firebase.js file

/**
 * Redeems points for a customer reward
 * @param {string} customerId - The customer's phone number/ID
 * @param {number} pointsToRedeem - Number of points to redeem
 * @param {string} rewardName - Name of the reward being redeemed
 * @returns {Promise<Object>} - Object containing success status and updated customer
 */
export const redeemPoints = async (customerId, pointsToRedeem, rewardName) => {
    try {
      // 1. Get customer data and validate points
      const customerRef = doc(db, "customers", customerId);
      const customerSnap = await getDoc(customerRef);
      
      if (!customerSnap.exists()) {
        throw new Error("Customer not found");
      }
      
      const customerData = customerSnap.data();
      const currentPoints = customerData.totalPoints || 0;
      
      if (currentPoints < pointsToRedeem) {
        throw new Error("Customer doesn't have enough points for this redemption");
      }
      
      // 2. Update customer's points balance
      const newTotalPoints = currentPoints - pointsToRedeem;
      
      await updateDoc(customerRef, {
        totalPoints: newTotalPoints,
        lastActive: serverTimestamp()
      });
      
      // 3. Add redemption record
      const redemptionRef = collection(db, "redemptions");
      await addDoc(redemptionRef, {
        customerId: customerId,
        customerName: customerData.name,
        pointsRedeemed: pointsToRedeem,
        rewardName: rewardName,
        status: "Completed",
        timestamp: serverTimestamp()
      });
      
      // 4. Add a transaction record for this redemption
      const transactionRef = collection(db, "customers", customerId, "transactions");
      await addDoc(transactionRef, {
        amount: 0, // No purchase amount for redemptions
        points: -pointsToRedeem, // Negative points to show redemption
        timestamp: serverTimestamp(),
        isRedemption: true,
        rewardName: rewardName
      });
      
      // Also add to global transactions for reporting
      const globalTransactionRef = collection(db, "transactions");
      await addDoc(globalTransactionRef, {
        customerId: customerId,
        customerName: customerData.name,
        amount: 0,
        points: -pointsToRedeem,
        timestamp: serverTimestamp(),
        isRedemption: true,
        rewardName: rewardName
      });
      
      // 5. Return updated customer data
      return {
        success: true,
        customer: { 
          id: customerSnap.id, 
          ...customerData, 
          totalPoints: newTotalPoints 
        }
      };
    } catch (error) {
      console.error("Error redeeming points:", error);
      throw error;
    }
  };

// Customer functions
export const getCustomerByPhone = async (phoneNumber) => {
  const docRef = doc(db, "customers", phoneNumber);
  const docSnap = await getDoc(docRef);
  
  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() };
  } else {
    return null;
  }
};


// For createCustomer function
// export const createCustomer = async (phoneNumber, customerData) => {
//   const customerRef = doc(db, "customers", phoneNumber);
  
//   // Calculate raw points
//   const rawPoints = parseFloat(customerData.amount) * (customerData.pointsPerDollar || 10);
  
//   // Apply custom rounding: < 0.5 rounds down to 0, >= 0.5 rounds up to 1
//   const pointsEarned = Math.floor(rawPoints) + (rawPoints % 1 >= 0.5 ? 1 : 0);
  
//   // Rest of your function remains the same
//   const auth = getAuth();
//   const currentUser = auth.currentUser;
//   const userEmail = currentUser ? currentUser.email : 'unknown';
  
//   const employeeName = customerData.employeeName || '';
  
//   const newCustomerData = {
//     name: customerData.name,
//     city: customerData.city,
//     totalPoints: pointsEarned,
//     registrationDate: serverTimestamp(),
//     firstTransactionDate: serverTimestamp(),
//     lastActive: serverTimestamp(),
//     transactionCount: 1,
//     registeredBy: userEmail,
//     registeredByEmployee: employeeName
//   };
  
//   if (customerData.dateOfBirth) {
//     newCustomerData.dateOfBirth = new Date(customerData.dateOfBirth);
//   }
  
//   await setDoc(customerRef, newCustomerData);
  
//   const transactionRef = collection(db, "customers", phoneNumber, "transactions");
//   await addDoc(transactionRef, {
//     amount: parseFloat(customerData.amount),
//     points: pointsEarned,
//     timestamp: serverTimestamp(),
//     notificationSent: pointsEarned >= 1000,
//     employeeName: employeeName,
//     recordedBy: userEmail
//   });
  
//   const globalTransactionRef = collection(db, "transactions");
//   await addDoc(globalTransactionRef, {
//     customerId: phoneNumber,
//     customerName: customerData.name,
//     amount: parseFloat(customerData.amount),
//     points: pointsEarned,
//     timestamp: serverTimestamp(),
//     isFirstPurchase: true,
//     employeeName: employeeName,
//     recordedBy: userEmail
//   });
  
//   return getCustomerByPhone(phoneNumber);
// };

// // For addTransaction function
// export const addTransaction = async (phoneNumber, amount, multiplier = 1, pointsPerDollars = 1, employeeName = '') => {
//   // Ensure amount is a number
//   const numericAmount = parseFloat(amount);
//   if (isNaN(numericAmount) || numericAmount <= 0) {
//     throw new Error("Invalid amount");
//   }
  
//   // Ensure multiplier is a number
//   const numericMultiplier = parseFloat(multiplier);
//   const effectiveMultiplier = !isNaN(numericMultiplier) && numericMultiplier > 0 
//     ? numericMultiplier 
//     : 1;
  
//   // Calculate raw points with multiplier
//   const rawBasePoints = numericAmount * pointsPerDollars;
//   const rawPointsWithMultiplier = rawBasePoints * effectiveMultiplier;
  
//   // Apply custom rounding: < 0.5 rounds down to 0, >= 0.5 rounds up to 1
//   const pointsEarned = Math.floor(rawPointsWithMultiplier) + (rawPointsWithMultiplier % 1 >= 0.5 ? 1 : 0);
  
//   // Rest of your function remains the same
//   const auth = getAuth();
//   const currentUser = auth.currentUser;
//   const userEmail = currentUser ? currentUser.email : 'unknown';
  
//   const customerRef = doc(db, "customers", phoneNumber);
//   const customerSnap = await getDoc(customerRef);
  
//   if (!customerSnap.exists()) {
//     throw new Error("Customer not found");
//   }
  
//   const customerData = customerSnap.data();
//   const currentPoints = customerData.totalPoints || 0;
//   const newTotalPoints = currentPoints + pointsEarned;
//   const transactionCount = (customerData.transactionCount || 0) + 1;
  
//   const updateData = {
//     totalPoints: newTotalPoints,
//     lastActive: serverTimestamp(),
//     transactionCount: transactionCount
//   };
  
//   if (currentPoints === 0 || customerData.lastExpirationDate) {
//     updateData.firstTransactionDate = serverTimestamp();
//     console.log(`Customer ${phoneNumber} had 0 points or expired points - updating firstTransactionDate.`);
//   }
  
//   await updateDoc(customerRef, updateData);
  
//   const transactionData = {
//     amount: numericAmount,
//     points: pointsEarned,
//     timestamp: serverTimestamp(),
//     notificationSent: newTotalPoints >= 1000 && currentPoints < 1000,
//     promotionApplied: effectiveMultiplier > 1,
//     pointsMultiplier: effectiveMultiplier,
//     employeeName: employeeName,
//     recordedBy: userEmail
//   };
  
//   const transactionRef = collection(db, "customers", phoneNumber, "transactions");
//   await addDoc(transactionRef, transactionData);
  
//   const globalTransactionRef = collection(db, "transactions");
//   await addDoc(globalTransactionRef, {
//     ...transactionData,
//     customerId: phoneNumber,
//     customerName: customerData.name,
//     isFirstPurchase: false
//   });
  
//   return {
//     customer: await getCustomerByPhone(phoneNumber),
//     pointsEarned,
//     reachedThreshold: newTotalPoints >= 1000 && currentPoints < 1000
//   };
// };

// export const createCustomer = async (phoneNumber, customerData) => {
//   const customerRef = doc(db, "customers", phoneNumber);
  
//   // Calculate raw points
//   const rawPoints = parseFloat(customerData.amount) * (customerData.pointsPerDollar || 10);
  
//   // Apply custom rounding: < 0.5 rounds down to 0, >= 0.5 rounds up to 1
//   const pointsEarned = Math.floor(rawPoints) + (rawPoints % 1 >= 0.5 ? 1 : 0);
  
//   // Get user info
//   const auth = getAuth();
//   const currentUser = auth.currentUser;
//   const userEmail = currentUser ? currentUser.email : 'unknown';
  
//   const employeeName = customerData.employeeName || '';
  
//   const newCustomerData = {
//     name: customerData.name,
//     city: customerData.city,
//     totalPoints: pointsEarned,
//     registrationDate: serverTimestamp(),
//     firstTransactionDate: serverTimestamp(),
//     lastActive: serverTimestamp(),
//     transactionCount: 1,
//     registeredBy: userEmail,
//     registeredByEmployee: employeeName
//   };
  
//   if (customerData.dateOfBirth) {
//     newCustomerData.dateOfBirth = new Date(customerData.dateOfBirth);
//   }
  
//   await setDoc(customerRef, newCustomerData);
  
//   // Create transaction data with simple category field
//   const transactionData = {
//     amount: parseFloat(customerData.amount),
//     points: pointsEarned,
//     timestamp: serverTimestamp(),
//     notificationSent: pointsEarned >= 1000,
//     employeeName: employeeName,
//     recordedBy: userEmail
//   };
  
//   // Add category name if provided
//   if (customerData.category) {
//     transactionData.category = customerData.category.name;
//   }
  
//   // Add to customer's transactions collection
//   const transactionRef = collection(db, "customers", phoneNumber, "transactions");
//   await addDoc(transactionRef, transactionData);
  
//   // Add to global transactions
//   const globalTransactionRef = collection(db, "transactions");
//   await addDoc(globalTransactionRef, {
//     ...transactionData,
//     customerId: phoneNumber,
//     customerName: customerData.name,
//     isFirstPurchase: true
//   });
  
//   return getCustomerByPhone(phoneNumber);
// };

// export const addTransaction = async (phoneNumber, amount, multiplier = 1, pointsPerDollars = 1, employeeName = '', category = null) => {
//   // Ensure amount is a number
//   const numericAmount = parseFloat(amount);
//   if (isNaN(numericAmount) || numericAmount <= 0) {
//     throw new Error("Invalid amount");
//   }
  
//   // Ensure multiplier is a number
//   const numericMultiplier = parseFloat(multiplier);
//   const effectiveMultiplier = !isNaN(numericMultiplier) && numericMultiplier > 0 
//     ? numericMultiplier 
//     : 1;
  
//   // Calculate raw points with multiplier
//   const rawBasePoints = numericAmount * pointsPerDollars;
//   const rawPointsWithMultiplier = rawBasePoints * effectiveMultiplier;
  
//   // Apply custom rounding: < 0.5 rounds down to 0, >= 0.5 rounds up to 1
//   const pointsEarned = Math.floor(rawPointsWithMultiplier) + (rawPointsWithMultiplier % 1 >= 0.5 ? 1 : 0);
  
//   // Get user info
//   const auth = getAuth();
//   const currentUser = auth.currentUser;
//   const userEmail = currentUser ? currentUser.email : 'unknown';
  
//   const customerRef = doc(db, "customers", phoneNumber);
//   const customerSnap = await getDoc(customerRef);
  
//   if (!customerSnap.exists()) {
//     throw new Error("Customer not found");
//   }
  
//   const customerData = customerSnap.data();
//   const currentPoints = customerData.totalPoints || 0;
//   const newTotalPoints = currentPoints + pointsEarned;
//   const transactionCount = (customerData.transactionCount || 0) + 1;
  
//   const updateData = {
//     totalPoints: newTotalPoints,
//     lastActive: serverTimestamp(),
//     transactionCount: transactionCount
//   };
  
//   if (currentPoints === 0 || customerData.lastExpirationDate) {
//     updateData.firstTransactionDate = serverTimestamp();
//     console.log(`Customer ${phoneNumber} had 0 points or expired points - updating firstTransactionDate.`);
//   }
  
//   await updateDoc(customerRef, updateData);
  
//   // Create transaction data with simple category field
//   const transactionData = {
//     amount: numericAmount,
//     points: pointsEarned,
//     timestamp: serverTimestamp(),
//     notificationSent: newTotalPoints >= 1000 && currentPoints < 1000,
//     promotionApplied: effectiveMultiplier > 1,
//     pointsMultiplier: effectiveMultiplier,
//     employeeName: employeeName,
//     recordedBy: userEmail
//   };
  
//   // Add category name if provided
//   if (category) {
//     transactionData.category = category.name;
//   }
  
//   // Add to customer's transactions collection
//   const transactionRef = collection(db, "customers", phoneNumber, "transactions");
//   await addDoc(transactionRef, transactionData);
  
//   // Add to global transactions
//   const globalTransactionRef = collection(db, "transactions");
//   await addDoc(globalTransactionRef, {
//     ...transactionData,
//     customerId: phoneNumber,
//     customerName: customerData.name,
//     isFirstPurchase: false
//   });
  
//   return {
//     customer: await getCustomerByPhone(phoneNumber),
//     pointsEarned,
//     reachedThreshold: newTotalPoints >= 1000 && currentPoints < 1000
//   };
// };

export const createCustomer = async (phoneNumber, customerData) => {
  const customerRef = doc(db, "customers", phoneNumber);
  
  // Calculate raw points
  const rawPoints = parseFloat(customerData.amount) * (customerData.pointsPerDollar || 10);
  
  // Apply custom rounding: < 0.5 rounds down to 0, >= 0.5 rounds up to 1
  const pointsEarned = Math.floor(rawPoints) + (rawPoints % 1 >= 0.5 ? 1 : 0);
  
  // Get user info
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const userEmail = currentUser ? currentUser.email : 'unknown';
  
  const employeeName = customerData.employeeName || '';
  
  const newCustomerData = {
    name: customerData.name,
    city: customerData.city,
    totalPoints: pointsEarned,
    registrationDate: serverTimestamp(),
    firstTransactionDate: serverTimestamp(),
    lastActive: serverTimestamp(),
    transactionCount: 1,
    registeredBy: userEmail,
    registeredByEmployee: employeeName
  };
  
  if (customerData.dateOfBirth) {
    newCustomerData.dateOfBirth = new Date(customerData.dateOfBirth);
  }
  
  await setDoc(customerRef, newCustomerData);
  
  // Create transaction data with simple category field and notes
  const transactionData = {
    amount: parseFloat(customerData.amount),
    points: pointsEarned,
    timestamp: serverTimestamp(),
    notificationSent: pointsEarned >= 1000,
    employeeName: employeeName,
    recordedBy: userEmail
  };
  
  // Add category name if provided
  if (customerData.category) {
    transactionData.category = customerData.category.name;
  }
  
  // Add notes if provided
  if (customerData.notes) {
    transactionData.notes = customerData.notes;
  }
  
  // Add to customer's transactions collection
  const transactionRef = collection(db, "customers", phoneNumber, "transactions");
  await addDoc(transactionRef, transactionData);
  
  // Add to global transactions
  const globalTransactionRef = collection(db, "transactions");
  await addDoc(globalTransactionRef, {
    ...transactionData,
    customerId: phoneNumber,
    customerName: customerData.name,
    isFirstPurchase: true
  });
  
  return getCustomerByPhone(phoneNumber);
};

// Update the addTransaction function to include notes
export const addTransaction = async (
  phoneNumber, 
  amount, 
  multiplier = 1, 
  pointsPerDollars = 1, 
  employeeName = '', 
  category = null,
  notes = null
) => {
  // Ensure amount is a number
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount) || numericAmount <= 0) {
    throw new Error("Invalid amount");
  }
  
  // Ensure multiplier is a number
  const numericMultiplier = parseFloat(multiplier);
  const effectiveMultiplier = !isNaN(numericMultiplier) && numericMultiplier > 0 
    ? numericMultiplier 
    : 1;
  
  // Calculate raw points with multiplier
  const rawBasePoints = numericAmount * pointsPerDollars;
  const rawPointsWithMultiplier = rawBasePoints * effectiveMultiplier;
  
  // Apply custom rounding: < 0.5 rounds down to 0, >= 0.5 rounds up to 1
  const pointsEarned = Math.floor(rawPointsWithMultiplier) + (rawPointsWithMultiplier % 1 >= 0.5 ? 1 : 0);
  
  // Get user info
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const userEmail = currentUser ? currentUser.email : 'unknown';
  
  const customerRef = doc(db, "customers", phoneNumber);
  const customerSnap = await getDoc(customerRef);
  
  if (!customerSnap.exists()) {
    throw new Error("Customer not found");
  }
  
  const customerData = customerSnap.data();
  const currentPoints = customerData.totalPoints || 0;
  const newTotalPoints = currentPoints + pointsEarned;
  const transactionCount = (customerData.transactionCount || 0) + 1;
  
  const updateData = {
    totalPoints: newTotalPoints,
    lastActive: serverTimestamp(),
    transactionCount: transactionCount
  };
  
  if (currentPoints === 0 || customerData.lastExpirationDate) {
    updateData.firstTransactionDate = serverTimestamp();
    console.log(`Customer ${phoneNumber} had 0 points or expired points - updating firstTransactionDate.`);
  }
  
  await updateDoc(customerRef, updateData);
  
  // Create transaction data with simple category field
  const transactionData = {
    amount: numericAmount,
    points: pointsEarned,
    timestamp: serverTimestamp(),
    notificationSent: newTotalPoints >= 1000 && currentPoints < 1000,
    promotionApplied: effectiveMultiplier > 1,
    pointsMultiplier: effectiveMultiplier,
    employeeName: employeeName,
    recordedBy: userEmail
  };
  
  // Add category name if provided
  if (category) {
    transactionData.category = category.name;
  }
  
  // Add notes if provided
  if (notes) {
    transactionData.notes = notes;
  }
  
  // Add to customer's transactions collection
  const transactionRef = collection(db, "customers", phoneNumber, "transactions");
  await addDoc(transactionRef, transactionData);
  
  // Add to global transactions
  const globalTransactionRef = collection(db, "transactions");
  await addDoc(globalTransactionRef, {
    ...transactionData,
    customerId: phoneNumber,
    customerName: customerData.name,
    isFirstPurchase: false
  });
  
  return {
    customer: await getCustomerByPhone(phoneNumber),
    pointsEarned,
    reachedThreshold: newTotalPoints >= 1000 && currentPoints < 1000
  };
};

export const getTransactions = async (phoneNumber) => {
  const transactionsRef = collection(db, "customers", phoneNumber, "transactions");
  const q = query(transactionsRef, orderBy("timestamp", "desc"));
  const querySnapshot = await getDocs(q);
  
  const transactions = [];
  querySnapshot.forEach((doc) => {
    transactions.push({ id: doc.id, ...doc.data() });
  });
  
  return transactions;
};

// New functions for dashboard
export const getAllCustomers = async () => {
  const customersRef = collection(db, "customers");
  const q = query(customersRef, orderBy("lastActive", "desc"));
  const querySnapshot = await getDocs(q);
  
  const customers = [];
  querySnapshot.forEach((doc) => {
    customers.push({ id: doc.id, ...doc.data() });
  });
  
  return customers;
};

export const getRecentCustomers = async (count = 5) => {
  const customersRef = collection(db, "customers");
  const q = query(customersRef, orderBy("registrationDate", "desc"), limit(count));
  const querySnapshot = await getDocs(q);
  
  const customers = [];
  querySnapshot.forEach((doc) => {
    customers.push({ id: doc.id, ...doc.data() });
  });
  
  return customers;
};

export const getTopCustomers = async (count = 5) => {
  const customersRef = collection(db, "customers");
  const q = query(customersRef, orderBy("totalPoints", "desc"), limit(count));
  const querySnapshot = await getDocs(q);
  
  const customers = [];
  querySnapshot.forEach((doc) => {
    customers.push({ id: doc.id, ...doc.data() });
  });
  
  return customers;
};

export const getEligibleCustomers = async () => {
  const customersRef = collection(db, "customers");
  const q = query(customersRef, where("totalPoints", ">=", 1000));
  const querySnapshot = await getDocs(q);
  
  const customers = [];
  querySnapshot.forEach((doc) => {
    customers.push({ id: doc.id, ...doc.data() });
  });
  
  return customers;
};

export const getAllTransactions = async (limit = 50) => {
  const transactionsRef = collection(db, "transactions");
  const q = query(transactionsRef, orderBy("timestamp", "desc"), limit);
  const querySnapshot = await getDocs(q);
  
  const transactions = [];
  querySnapshot.forEach((doc) => {
    transactions.push({ id: doc.id, ...doc.data() });
  });
  
  return transactions;
};

// Add this function to your firebase.js file

export const getTopPerformingDays = async () => {
    try {
      console.log("Getting top performing days data...");
      const transactionsRef = collection(db, "transactions");
      const q = query(transactionsRef, orderBy("timestamp", "desc"), limit(100));
      const querySnapshot = await getDocs(q);
      
      console.log(`Found ${querySnapshot.size} transactions for day analysis`);
      
      // Create a map to store the data for each day
      const dayStats = {
        'Sun': { totalAmount: 0, count: 0 },
        'Mon': { totalAmount: 0, count: 0 },
        'Tue': { totalAmount: 0, count: 0 },
        'Wed': { totalAmount: 0, count: 0 },
        'Thu': { totalAmount: 0, count: 0 },
        'Fri': { totalAmount: 0, count: 0 },
        'Sat': { totalAmount: 0, count: 0 }
      };
      
      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      
      // For debugging - check field names in first transaction
      if (!querySnapshot.empty) {
        const firstDoc = querySnapshot.docs[0];
        const firstTransaction = firstDoc.data();
        console.log("First transaction fields:", Object.keys(firstTransaction));
        console.log("Amount field value:", firstTransaction.amount, 
                    "| amount50 value:", firstTransaction.amount50);
      }
      
      querySnapshot.forEach((doc) => {
        const transaction = doc.data();
        if (transaction.timestamp) {
          try {
            const date = transaction.timestamp.toDate();
            const dayOfWeek = dayNames[date.getDay()];
            
            // Get amount - check both field names (amount and amount50)
            const transactionAmount = 
              transaction.amount !== undefined ? Number(transaction.amount) : 
              transaction.amount50 !== undefined ? Number(transaction.amount50) : 0;
            
            dayStats[dayOfWeek].totalAmount += transactionAmount;
            dayStats[dayOfWeek].count += 1;
          } catch (err) {
            console.error("Error processing transaction for day stats:", err);
          }
        }
      });
      
      // Convert to array and calculate average
      const result = dayNames.map(day => ({
        day,
        totalAmount: dayStats[day].totalAmount,
        count: dayStats[day].count,
        average: dayStats[day].count > 0 ? dayStats[day].totalAmount / dayStats[day].count : 0
      }));
      
      console.log("Day stats calculated:", result);
      return result;
    } catch (err) {
      console.error("Error getting top performing days:", err);
      // Return empty array with day names to avoid errors in the chart
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => ({
        day,
        totalAmount: 0,
        count: 0,
        average: 0
      }));
    }
  };

  // Reward Tiers
export const getRewardTiers = async () => {
    const tiersRef = collection(db, "rewardTiers");
    const q = query(tiersRef, orderBy("pointsRequired", "asc"));
    const querySnapshot = await getDocs(q);
    
    const tiers = [];
    querySnapshot.forEach((doc) => {
      tiers.push({ id: doc.id, ...doc.data() });
    });
    
    return tiers;
  };
  
  export const createRewardTier = async (tierData) => {
    const tiersRef = collection(db, "rewardTiers");
    const docRef = await addDoc(tiersRef, tierData);
    
    return {
      id: docRef.id,
      ...tierData
    };
  };
  
  export const updateRewardTier = async (tierId, tierData) => {
    const tierRef = doc(db, "rewardTiers", tierId);
    await updateDoc(tierRef, tierData);
    return true;
  };
  
  // Promotions
  export const getPromotion = async () => {
    const promoRef = collection(db, "promotions");
    const q = query(promoRef, orderBy("startDate", "desc"));
    const querySnapshot = await getDocs(q);
    
    const promotions = [];
    querySnapshot.forEach((doc) => {
      promotions.push({ id: doc.id, ...doc.data() });
    });
    
    return promotions;
  };
  
  export const createPromotion = async (promoData) => {
    const promoRef = collection(db, "promotions");
    const docRef = await addDoc(promoRef, promoData);
    
    return {
      id: docRef.id,
      ...promoData
    };
  };
  
  export const updatePromotion = async (promoId, promoData) => {
    const promoRef = doc(db, "promotions", promoId);
    await updateDoc(promoRef, promoData);
    return true;
  };
  
  export const deletePromotion = async (promoId) => {
    const promoRef = doc(db, "promotions", promoId);
    await deleteDoc(promoRef);
    return true;
  };

  // Replace the current getAppSettings function in firebase.js
  export const getAppSettings = async () => {
    try {
      const settingsRef = doc(db, "settings", "rewards");
      const docSnap = await getDoc(settingsRef);
      console.log("Exists?", docSnap.exists());
      console.log("Data:", docSnap.data());

      
      // In firebase.js, update getAppSettings to handle missing fields:
if (docSnap.exists()) {
  const data = docSnap.data();
  return {
    pointsPerDollar: data.pointsPerDollar ?? 10, // Use nullish coalescing
    minRedemptionPoints: data.minRedemptionPoints ?? 1000,
    expirationMonths: data.expirationMonths ?? 12,
    birthdayDiscountPercentage: data.birthdayDiscountPercentage ?? 10
  };
} else {
        // If no settings document exists, create one with defaults
        const defaultSettings = {
          pointsPerDollar: 10,
          expirationMonths: 12,
          minRedemptionPoints: 1000,
          birthdayDiscountPercentage: 10
        };
        
        await setDoc(settingsRef, defaultSettings);
        return defaultSettings;
      }
    } catch (error) {
      console.error("Error getting app settings:", error);
      throw error;
    }
  };
  
  // Replace the current updateAppSettings function in firebase.js
  export const updateAppSettings = async (settingsData) => {
    try {
      const settingsRef = doc(db, "settings", "rewards");
      await setDoc(settingsRef, settingsData, { merge: true });
      return true;
    } catch (error) {
      console.error("Error updating app settings:", error);
      throw error;
    }
  };
  
  export const updateCustomerName = async (customerId, newName) => {
    try {
      const customerRef = doc(db, "customers", customerId);
      await updateDoc(customerRef, {
        name: newName
      });
      return true;
    } catch (error) {
      console.error("Error updating customer name:", error);
      throw error;
    }
  };
  // Add this function to firebase.js
  export const updateCustomerInfo = async (oldCustomerId, newCustomerId, newName, newDateOfBirth) => {
    try {
      const db = getFirestore();
      const batch = writeBatch(db);
      
      // Get current customer data
      const customerRef = doc(db, "customers", oldCustomerId);
      const customerSnap = await getDoc(customerRef);
      
      if (!customerSnap.exists()) {
        throw new Error("Customer not found");
      }
      
      const customerData = customerSnap.data();
      
      // Check if phone number changed
      if (oldCustomerId !== newCustomerId) {
        // Create a new customer document with the new ID
        const newCustomerRef = doc(db, "customers", newCustomerId);
        
        // Prepare the data for the new document
        const newCustomerData = {
          ...customerData,
          name: newName,
          id: newCustomerId,
        };
        
        // Handle dateOfBirth update
        if (newDateOfBirth) {
          newCustomerData.dateOfBirth = new Date(newDateOfBirth);
        } else if (newCustomerData.dateOfBirth) {
          // Keep existing date of birth
        } else {
          // No dateOfBirth in old or new data
          delete newCustomerData.dateOfBirth;
        }
        
        // Set new document
        batch.set(newCustomerRef, newCustomerData);
        
        // Delete old document
        batch.delete(customerRef);
        
        // Also need to move all transactions to the new customer ID
        const transactionsRef = collection(db, "customers", oldCustomerId, "transactions");
        const transactionsSnapshot = await getDocs(transactionsRef);
        
        // Copy each transaction to the new customer's subcollection
        transactionsSnapshot.forEach((transactionDoc) => {  // Renamed doc to transactionDoc
          const transactionData = transactionDoc.data();
          const newTransactionRef = doc(
            db, 
            "customers", 
            newCustomerId, 
            "transactions", 
            transactionDoc.id  // Use transactionDoc.id here
          );
          batch.set(newTransactionRef, transactionData);
        });
        
        // Update global transactions references
        const globalTransactionsRef = collection(db, "transactions");
        const globalQuery = query(
          globalTransactionsRef, 
          where("customerId", "==", oldCustomerId)
        );
        const globalSnapshot = await getDocs(globalQuery);
        
        globalSnapshot.forEach((globalDoc) => {  // Renamed doc to globalDoc
          batch.update(globalDoc.ref, {
            customerId: newCustomerId,
            customerName: newName
          });
        });
      } else {
        // Just update the existing customer document
        const updateData = {
          name: newName
        };
        
        // Handle dateOfBirth update
        if (newDateOfBirth) {
          updateData.dateOfBirth = new Date(newDateOfBirth);
        }
        
        batch.update(customerRef, updateData);
        
        // Update customer name in global transactions
        if (customerData.name !== newName) {
          const globalTransactionsRef = collection(db, "transactions");
          const globalQuery = query(
            globalTransactionsRef, 
            where("customerId", "==", oldCustomerId)
          );
          const globalSnapshot = await getDocs(globalQuery);
          
          globalSnapshot.forEach((globalDoc) => {  // Renamed doc to globalDoc
            batch.update(globalDoc.ref, {
              customerName: newName
            });
          });
        }
      }
      
      // Commit all the changes
      await batch.commit();
      
      return true;
    } catch (error) {
      console.error("Error updating customer information:", error);
      throw error;
    }
  };

/**
 * Deletes a transaction and updates the customer's points balance
 * @param {string} customerId - The customer's phone number/ID
 * @param {string} transactionId - The ID of the transaction to delete
 * @param {number} points - The number of points to subtract from customer's balance
 * @param {Object} transactionData - The transaction data object
 * @returns {Promise<boolean>} - Success status
 */
// export const deleteTransaction = async (customerId, transactionId, points, transactionData) => {
//   try {
//     // Get a reference to Firestore
//     const db = getFirestore();
    
//     // Start a batch operation for atomicity
//     const batch = writeBatch(db);
    
//     // 1. Delete the transaction from the customer's subcollection
//     const customerTransactionRef = doc(db, "customers", customerId, "transactions", transactionId);
//     batch.delete(customerTransactionRef);
    
//     // 2. Find and delete matching transaction from global transactions
//     // Note: We need to fetch it first since we only have the customer's transaction ID
//     // If you store the global transaction ID in the customer transaction, you could use that directly
//     if (transactionData && transactionData.timestamp) {
//       // This is an approximation - in a real app, you might want to store the global transaction ID 
//       // in the customer transaction document to make this more reliable
//       const globalTransactionsRef = collection(db, "transactions");
//       const q = query(
//         globalTransactionsRef, 
//         where("customerId", "==", customerId),
//         where("points", "==", points),
//         // We need to be careful with timestamp comparison due to potential small differences
//         // This is why storing a reference is better
//         orderBy("timestamp", "desc"),
//         limit(5) // Get a few to find the right match
//       );
      
//       const querySnapshot = await getDocs(q);
      
//       let globalTransactionFound = false;
//       querySnapshot.forEach((doc) => {
//         const globalTransaction = doc.data();
//         // Basic check - may need to improve with additional fields
//         if (
//           !globalTransactionFound &&
//           globalTransaction.customerId === customerId &&
//           globalTransaction.points === points &&
//           Math.abs(
//             globalTransaction.timestamp.toMillis() - 
//             transactionData.timestamp.toMillis()
//           ) < 5000 // Within 5 seconds
//         ) {
//           batch.delete(doc.ref);
//           globalTransactionFound = true;
//         }
//       });
//     }
    
//     // 3. Update the customer's points balance
//     const customerRef = doc(db, "customers", customerId);
//     const customerSnapshot = await getDoc(customerRef);
    
//     if (customerSnapshot.exists()) {
//       const customerData = customerSnapshot.data();
//       const currentPoints = customerData.totalPoints || 0;
      
//       // If this is a regular transaction, we need to subtract the points
//       // If it's a redemption (negative points), we need to add them back
//       const newPoints = currentPoints - points;
      
//       batch.update(customerRef, {
//         totalPoints: newPoints,
//         lastActive: serverTimestamp()
//       });
//     }
    
//     // 4. Commit the batch
//     await batch.commit();
    
//     return true;
//   } catch (error) {
//     console.error("Error deleting transaction:", error);
//     throw error;
//   }
// };

// Update the existing deleteTransaction function in firebase.js
// export const deleteTransaction = async (customerId, transactionId, points, transactionData) => {
//   try {
//     // Get a reference to Firestore
//     const db = getFirestore();
    
//     // Start a batch operation for atomicity
//     const batch = writeBatch(db);
    
//     // 1. Mark the transaction as deleted in the customer's subcollection instead of removing it
//     const customerTransactionRef = doc(db, "customers", customerId, "transactions", transactionId);
//     batch.update(customerTransactionRef, {
//       isDeleted: true,
//       deletedAt: serverTimestamp(),
//       deletedBy: getAuth().currentUser?.email || 'unknown',
//       originalPoints: points // Store original points for reference
//     });
    
//     // 2. Find and mark matching transaction from global transactions
//     if (transactionData && transactionData.timestamp) {
//       const globalTransactionsRef = collection(db, "transactions");
//       const q = query(
//         globalTransactionsRef, 
//         where("customerId", "==", customerId),
//         where("points", "==", points),
//         // We need to be careful with timestamp comparison due to potential small differences
//         orderBy("timestamp", "desc"),
//         limit(5) // Get a few to find the right match
//       );
      
//       const querySnapshot = await getDocs(q);
      
//       let globalTransactionFound = false;
//       querySnapshot.forEach((doc) => {
//         const globalTransaction = doc.data();
//         // Basic check to find the matching transaction
//         if (
//           !globalTransactionFound &&
//           globalTransaction.customerId === customerId &&
//           globalTransaction.points === points &&
//           Math.abs(
//             globalTransaction.timestamp.toMillis() - 
//             transactionData.timestamp.toMillis()
//           ) < 5000 // Within 5 seconds
//         ) {
//           batch.update(doc.ref, {
//             isDeleted: true,
//             deletedAt: serverTimestamp(),
//             deletedBy: getAuth().currentUser?.email || 'unknown'
//           });
//           globalTransactionFound = true;
//         }
//       });
//     }
    
//     // 3. Update the customer's points balance
//     const customerRef = doc(db, "customers", customerId);
//     const customerSnapshot = await getDoc(customerRef);
    
//     if (customerSnapshot.exists()) {
//       const customerData = customerSnapshot.data();
//       const currentPoints = customerData.totalPoints || 0;
      
//       // If this is a regular transaction, we need to subtract the points
//       // If it's a redemption (negative points), we need to add them back
//       const newPoints = currentPoints - points;
      
//       batch.update(customerRef, {
//         totalPoints: newPoints,
//         lastActive: serverTimestamp()
//       });
//     }
    
//     // 4. Commit the batch
//     await batch.commit();
    
//     return true;
//   } catch (error) {
//     console.error("Error marking transaction as deleted:", error);
//     throw error;
//   }
// };

export const deleteTransaction = async (customerId, transactionId, points, transactionData) => {
  try {
    // Get a reference to Firestore
    const db = getFirestore();
    
    // Start a batch operation for atomicity
    const batch = writeBatch(db);
    
    // 1. Mark the transaction as deleted in the customer's subcollection
    const customerTransactionRef = doc(db, "customers", customerId, "transactions", transactionId);
    batch.update(customerTransactionRef, {
      isDeleted: true,
      deletedAt: serverTimestamp(),
      deletedBy: getAuth().currentUser?.email || 'unknown',
      originalPoints: points // Store original points for reference
    });
    
    // 2. Find and mark matching transaction from global transactions
    if (transactionData && transactionData.timestamp) {
      const globalTransactionsRef = collection(db, "transactions");
      const q = query(
        globalTransactionsRef, 
        where("customerId", "==", customerId),
        where("points", "==", points),
        orderBy("timestamp", "desc"),
        limit(5)
      );
      
      const querySnapshot = await getDocs(q);
      
      let globalTransactionFound = false;
      querySnapshot.forEach((doc) => {
        const globalTransaction = doc.data();
        if (
          !globalTransactionFound &&
          globalTransaction.customerId === customerId &&
          globalTransaction.points === points &&
          Math.abs(
            globalTransaction.timestamp.toMillis() - 
            transactionData.timestamp.toMillis()
          ) < 5000
        ) {
          batch.update(doc.ref, {
            isDeleted: true,
            deletedAt: serverTimestamp(),
            deletedBy: getAuth().currentUser?.email || 'unknown'
          });
          globalTransactionFound = true;
        }
      });
    }
    
    // 3. Update the customer's points balance with safeguards
    const customerRef = doc(db, "customers", customerId);
    const customerSnapshot = await getDoc(customerRef);
    
    if (customerSnapshot.exists()) {
      const customerData = customerSnapshot.data();
      const currentPoints = customerData.totalPoints || 0;
      
      // Calculate new points - handle both positive and negative points
      let newPoints;
      if (points < 0) {
        // This was a redemption (negative points), so add them back
        newPoints = currentPoints - points; // Subtracting negative = adding
      } else {
        // This was a regular transaction, subtract the points
        newPoints = currentPoints - points;
        
        // SAFEGUARD: Don't let points go below 0 unless it was a redemption
        if (newPoints < 0) {
          console.warn(`Warning: Deleting transaction would result in negative points. 
                       Customer: ${customerId}, Current: ${currentPoints}, 
                       Subtracting: ${points}, Result: ${newPoints}`);
          
          // Option 1: Set to 0 (safest)
          newPoints = 0;
          
          // Option 2: Or throw an error to investigate
          // throw new Error(`Cannot delete transaction: would result in negative points (${newPoints})`);
        }
      }
      
      // Also decrease transaction count
      const newTransactionCount = Math.max((customerData.transactionCount || 1) - 1, 0);
      
      batch.update(customerRef, {
        totalPoints: newPoints,
        transactionCount: newTransactionCount,
        lastActive: serverTimestamp()
      });
      
      console.log(`Updated customer ${customerId}: ${currentPoints} → ${newPoints} points`);
    }
    
    // 4. Commit the batch
    await batch.commit();
    
    return true;
  } catch (error) {
    console.error("Error marking transaction as deleted:", error);
    throw error;
  }
};

export const getRedemptionHistory = async () => {
    try {
      const redemptionsRef = collection(db, "redemptions");
      const q = query(redemptionsRef, orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      
      const redemptions = [];
      querySnapshot.forEach((doc) => {
        redemptions.push({ id: doc.id, ...doc.data() });
      });
      
      return {
        history: redemptions
      };
    } catch (error) {
      console.error("Error getting redemption history:", error);
      throw error;
    }
  };
  
  // Staff Management
  export const getStaffMembers = async () => {
    // In a real app, you'd fetch from Firestore
    // This is sample data
    return [
      {
        id: 'staff1',
        email: 'owner@example.com',
        role: 'admin',
        status: 'active',
        isOwner: true
      },
      {
        id: 'staff2',
        email: 'manager@example.com',
        role: 'admin',
        status: 'active',
        isOwner: false
      },
      {
        id: 'staff3',
        email: 'staff@example.com',
        role: 'staff',
        status: 'active',
        isOwner: false
      },
      {
        id: 'staff4',
        email: 'viewer@example.com',
        role: 'viewer',
        status: 'pending',
        isOwner: false
      }
    ];
  };
  
  export const inviteStaffMember = async (staffData) => {
    // In a real app, you'd add the user to Firestore and send an invitation
    console.log('Inviting staff member:', staffData);
    
    // Simulate a delay to demonstrate loading state
    await new Promise(resolve => setTimeout(resolve, 800));
    
    return {
      id: 'new-staff-' + Date.now(),
      email: staffData.email,
      role: staffData.role,
      status: 'pending',
      isOwner: false
    };
  };
  
  export const updateStaffMember = async (memberId, updateData) => {
    // In a real app, you'd update the user in Firestore
    console.log('Updating staff member:', memberId, updateData);
    
    // Simulate a delay to demonstrate loading state
    await new Promise(resolve => setTimeout(resolve, 800));
    
    return true;
  };
  
  export const removeStaffMember = async (memberId) => {
    // In a real app, you'd remove the user from Firestore
    console.log('Removing staff member:', memberId);
    
    // Simulate a delay to demonstrate loading state
    await new Promise(resolve => setTimeout(resolve, 800));
    
    return true;
  };

export const getTotalStats = async () => {
  // Get all customers to calculate statistics
  const customersRef = collection(db, "customers");
  const customersSnapshot = await getDocs(customersRef);
  
  let totalCustomers = 0;
  let totalPoints = 0;
  let totalTransactions = 0;
  
  customersSnapshot.forEach((doc) => {
    const customer = doc.data();
    totalCustomers++;
    totalPoints += customer.totalPoints || 0;
    totalTransactions += customer.transactionCount || 0;
  });
  
  const averagePoints = totalCustomers > 0 ? Math.round(totalPoints / totalCustomers) : 0;
  
  return {
    totalCustomers,
    totalPoints,
    totalTransactions,
    averagePoints
  };
};

// Add these imports at the top of firebase.js


// Initialize Firebase Storage


/**
 * Uploads an image for a reward tier and returns the download URL
 * @param {File} imageFile - The image file to upload
 * @param {string} tierId - The ID of the reward tier
 * @returns {Promise<string>} - The download URL of the uploaded image
 */
export const uploadRewardImage = async (imageFile, tierId) => {
  try {
    // Create a storage reference with a unique path
    const imagePath = `reward-images/${tierId}/${Date.now()}_${imageFile.name}`;
    const imageRef = storageRef(storage, imagePath);
    
    // Upload the file
    const snapshot = await uploadBytes(imageRef, imageFile);
    
    // Get the download URL
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

/**
 * Deletes an image from storage
 * @param {string} imageUrl - The URL of the image to delete
 * @returns {Promise<boolean>} - Success status
 */
export const deleteRewardImage = async (imageUrl) => {
  try {
    // Extract the path from the URL
    // This requires knowledge of your storage URL format
    // For example: https://firebasestorage.googleapis.com/v0/b/your-project.appspot.com/o/reward-images%2Ftier-id%2Fimage-name?alt=media&token=token
    
    const url = new URL(imageUrl);
    const path = decodeURIComponent(url.pathname.split('/o/')[1].split('?')[0]);
    
    const imageRef = storageRef(storage, path);
    await deleteObject(imageRef);
    return true;
  } catch (error) {
    console.error("Error deleting image:", error);
    // Don't throw here, as this is a cleanup operation
    return false;
  }
};

// Modify the existing deleteRewardTier function to also delete associated images
export const deleteRewardTier = async (tierId) => {
  try {
    // First, get the tier data to check if it has an image
    const tierRef = doc(db, "rewardTiers", tierId);
    const tierSnap = await getDoc(tierRef);

    if (tierSnap.exists()) {
      const tierData = tierSnap.data();

      // If the tier has an image, delete it
      if (tierData.imageUrl) {
        await deleteRewardImage(tierData.imageUrl);
      }
    }

    // Delete the tier document
    await deleteDoc(tierRef);
    return true;
  } catch (error) {
    console.error("Error deleting reward tier:", error);
    throw error;
  }
};

// SMS Cloud Function wrappers
export const checkSmsBalanceViaProxy = async (providerId = 1) => {
  const fn = httpsCallable(functions, 'checkSmsBalance');
  const result = await fn({ providerId });
  return result.data;
};

export const sendSmsViaProxy = async (phone, message) => {
  const fn = httpsCallable(functions, 'sendSms');
  const result = await fn({ phone, message });
  return result.data;
};